import {ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList} from "@angular/core";
import {SimpleGridRecordComponent} from "./simple-grid-record.component";

@Component({
  selector: 'simpleGridTable',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .simpleTable {
      background-color: var(--background-color7);
      width: 100%;
    }
    * {
      font-size: 0.9em;
    }
  `],
  template: `
    <table class="table simpleTable">
      <ng-content></ng-content>
    </table>
  `,
})

export class SimpleGridTableComponent {
  @Input() sort;

  @Input() list;

  private selected;

  @ContentChildren(SimpleGridRecordComponent, {descendants: true}) simpleGridRecord: QueryList<SimpleGridRecordComponent>;

  public setSelected(i_selected: SimpleGridRecordComponent) {
    this.deselect();
    this.selected = i_selected;
    // var rec = i_selected.item;
    // console.log(`user selected ${rec.getBusinessId()}  ${rec.getName()} ${rec.getAccessMask()}`);
  }

  public deselect() {
    this.selected = null;
    if (!this.simpleGridRecord)
      return;
    this.simpleGridRecord.map((i_simpleGridRecord: SimpleGridRecordComponent) => {
      i_simpleGridRecord.selectedClass = false;
    });
  }

  public getSelected(): SimpleGridRecordComponent {
    return this.selected;
  }
}
